export enum NewProductsETA {
  RECENTLY_UPDATED = "recently-updated",
  IMMINENT = "imminent",
  COMING_SOON = "coming-soon",
  PLANNED = "planned",
  PILOT = "pilot"
}
